import { createReducer, on } from '@ngrx/store';
import { LoggedUserState } from '../states/logged-user.state';
import { setLoggedUser } from '../actions/logged-user.actions';

export const initialState: LoggedUserState = {
  loggedUser: undefined,
};

export const LoggedUserReducers = createReducer(
  initialState,
  on(setLoggedUser, (state, { loggedUser }) => {
    return { ...state, loggedUser };
  })
);
